import React from 'react';
import { Dropdown, Form } from 'react-bootstrap';

function LabsMultiselectDropdown({ samples, values, setFieldValue, errors, touched }) {
  const selectedLabs = values.lab_id || [];

  const handleSampleChange = (labId) => {
    if (selectedLabs.includes(labId)) {
      setFieldValue("lab_id", selectedLabs.filter((id) => id !== labId));
    } else {
      setFieldValue("lab_id", [...selectedLabs, labId]);
    }
  };
  return (
    <>
      <label htmlFor="lab_id" className="form-label">
        Lab<span className="text-red">*</span>
      </label>

      <Dropdown>
        <Dropdown.Toggle 
          id="statusFilterDropdown"
          className={`form-control`}
        >
          {selectedLabs.length > 0
            ? `${selectedLabs.length} Lab(s) selected`
            : "Select Labs"}
        </Dropdown.Toggle>
        <Dropdown.Menu className="el-admin">
          <form>
            {samples.map((sample) => {
              const isChecked = selectedLabs.includes(sample.id);
              return (
                <Form.Group controlId={sample.id} key={sample.id}>
                  <Form.Check
                    type="checkbox"
                    label={sample.name}
                    checked={isChecked}
                    onChange={() => handleSampleChange(sample.id)}
                  />
                </Form.Group>
              );
            })}
          </form>
          <div>
          
        <input
            type="button"
            value="Clear All"
            className="btn btn-link"
            onClick={() => setFieldValue("lab_id", [])}
        />

          </div>
        </Dropdown.Menu>
      </Dropdown>

      {touched.lab_id && errors.lab_id && (
        <div className="text-danger">{errors.lab_id}</div>
      )}
    </>
  );
}

export default LabsMultiselectDropdown;
